import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, TicketsPianificati } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsPianificatiService extends CrudGenericsService<TicketsPianificati, string> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsPianificati`);
    this.base = `${env.apiUrl}/api/TicketsPianificati/`;
  }

  // calendario per consuntivo trasporti
  public Get_DdtGiornaliero1Month(month_start_date: any): Observable<any[]> {
    const u = `${this.base}Get_DdtGiornaliero1Month?month_start_date=${month_start_date}`;
    return this.http.get<any[]>(u);
    /*
      return this.http.get<any[]>(u).pipe(
        map((results: LottiDdtGiornalieroMonthModel[]) => {
          return results.map((db: LottiDdtGiornalieroMonthModel) => {
            return {
              id: `${db.Chiave}`,
              title: db.DisplayCalendar,
              start: new Date(Date.parse(db.Giorno)),
              color: { primary: '#000', secondary: '#E3EDF5' },
              allDay: true,
              draggable: false,
              meta: {
                db: db.LottiDdtGiornalieroModel,
              },
            };
          });
        })
      );*/
  }
}
